import { IProductTilePriceAndBrandNameXP } from '../../indigofair/data/IProductTilePriceAndBrandNameXP';
import { SettingConst } from '../../types';

/**
 * Experiment to use updated price line and brand name
 * https:www.notion.so/faire/Price-first-product-tile-1292efb5c25a805083efd28ffdd4d85b?pvs=4
 * https:www.notion.so/faire/Improve-path-to-brand-page-on-product-tile-1292efb5c25a80c788eeddb90f39cbbf?pvs=4
 */
export const PRICE_FIRST_AND_NEW_BRAND_LINK_ON_SEARCH_TILE_241029 =
  'PRICE_FIRST_AND_NEW_BRAND_LINK_ON_SEARCH_TILE_241029' as SettingConst<
    'PRICE_FIRST_AND_NEW_BRAND_LINK_ON_SEARCH_TILE_241029',
    keyof typeof IProductTilePriceAndBrandNameXP.Bucket,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
